import styled from '@emotion/styled';

import { lightenDarkenColor } from 'utils/colors';

import vars from 'theme/styles/vars';

export default styled.div`
    width: 100%;

    textarea {
        width: 100%;
        height: 100%;
        color: ${vars.colorTextDark};
        padding: 1em 1em;
        border: none;
        border-radius: 0.5em;
        font-size: 0.9em;

        &::placeholder {
            color: ${lightenDarkenColor(vars.colorPrimary, -100)};
        }

        &:disabled {
            background-color: #d7e2e4;
        }

        &.decorator-left {
            input {
                padding-left: 2.5em;
            }
        }
        &.decorator-right {
            input {
                padding-right: 2.5em;
            }
        }

        @media all and (max-width: ${vars.mobileL}) {
            font-size: 1.1em;
        }
    }

    .internal-wrapper {
        border: none;
    }

    .max-length {
        color: ${vars.colorTextWhite};
        font-size: .7em;
        text-align: right;
        width: 100%;
        margin-top: .5em;

        &.limit {
            color: ${vars.colorAlert};
        }
    }
`;
